import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';

export const DeleteServiceFocus = createAsyncThunk(
  'serviceFocuses/delete',
  async (id: number, dispatch: any) => {
    const axios = dispatch.getState().core.axios;

    try {
      const response = await axios.delete(`/api/ServiceFocuses/${id}`);

      if (response.status !== 200 && response.status !== 204) {
        createNotification('Could not delete service focus.', 'error');
        throw new Error('Failed to delete service focus');
      }

      createNotification('Service focus deleted successfully.', 'success');
      return id; 
    } catch (error) {
      createNotification('An error occurred while deleting service focus.', 'error');
      throw error;
    }
  }
);